export const tournamentParticipantMode = [
    'Single',
    'RandomTeams',
    'SkillbasedTeams',
    'CustomTeams',
];